import { ACCENT, ACCENT_LIGHT, ACCENT_MID } from "../constants/theme";

export default function SectionLabel({ children }) {
  return (
    <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: ACCENT_LIGHT, borderRadius: 20, padding: "6px 16px", marginBottom: 16 }}>
      <div style={{ width: 6, height: 6, borderRadius: "50%", background: ACCENT }} />
      <span style={{ color: ACCENT, fontWeight: 700, fontSize: 12.5, textTransform: "uppercase", letterSpacing: "0.08em" }}>{children}</span>
    </div>
  );
}
